import { render, staticRenderFns } from "./RouteTemplateDetailFormDataView.vue?vue&type=template&id=d855c32a&scoped=true&"
import script from "./RouteTemplateDetailFormDataView.vue?vue&type=script&lang=js&"
export * from "./RouteTemplateDetailFormDataView.vue?vue&type=script&lang=js&"
import style0 from "./RouteTemplateDetailFormDataView.vue?vue&type=style&index=0&id=d855c32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d855c32a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
